import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = (props) => {
    const location = useLocation();
    const { isLoggedIn, token, user } = useSelector((state) => state.authSlice);
    const isChangePasswordRoute = location.pathname === '/profile/change-password';
    const needsPasswordReset = Boolean(user?.mustChangePassword);

    if (!isLoggedIn || !token) {
        return <Navigate to="/login" replace={true} />;
    }

    if (needsPasswordReset && !isChangePasswordRoute) {
        return (
            <Navigate
                to="/profile/change-password"
                replace={true}
                state={{ forcePasswordChange: true }}
            />
        );
    }

    return props.children;
};

export default ProtectedRoute;
